export default Object.freeze({
  boardName : 20,
  userName  : 12,
});
